import { render } from "./CommunitiesList.vue?vue&type=template&id=a189f0da&scoped=true"
import script from "./CommunitiesList.vue?vue&type=script&lang=js"
export * from "./CommunitiesList.vue?vue&type=script&lang=js"

import "./CommunitiesList.vue?vue&type=style&index=0&id=a189f0da&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a189f0da"]])

export default __exports__